import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { detailProduction } from "../store/dataSlice";
import { Table, Card, Button } from "antd";
import dayjs from "dayjs";
const ProductionDetail = ({ record }) => {
  console.log(record);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      detailProduction({ production_plan_id: record.production_plan_id })
    );
  }, [record]);
  const data = useSelector((state) => state.production.data?.detailProduction);
  const columns = [
    {
      title: <span className="text-gray-500">Material Grade</span>,
      dataIndex: ["Product", "MaterialGrade", "number"],
      width: 180,
    },
    {
      title: <span className="text-gray-500">Product</span>,
      dataIndex: ["Product"],
      width: 280,
      render: (product) => (
        <>
          <div>
            <span className="text-gray-500">Part Name:</span>{" "}
            {product.part_name}
          </div>
          <div>
            <span className="text-gray-500">Description:</span>{" "}
            {product.description}
          </div>
        </>
      ),
    },
    {
      title: <span className="text-gray-500">Worker</span>,
      dataIndex: ["Worker", "worker_name"],
    },
    {
      title: <span className="text-gray-500">Process</span>,
      dataIndex: ["Process", "process_name"],
    },

    {
      title: <span className="text-gray-500">Quantity</span>,
      dataIndex: "quantity",
      width: 150,
    },
    {
      title: <span className="text-gray-500">category</span>,
      dataIndex: ["Product", "category"],
    },
    {
      title: <span className="text-gray-500">Drawing no.</span>,
      dataIndex: ["Product", "drawing_number"],
      width: 180,
    },
    {
      title: <span className="text-gray-500">Type</span>,
      dataIndex: ["Product", "type"],
    },

    {
      title: <span className="text-gray-500">Unit</span>,
      dataIndex: ["Product", "unit_measurement"],
    },
    {
      title: <span className="text-gray-500">Description</span>,
      dataIndex: "description",
    },
    {
      title: <span className="text-gray-500">From Date to Date</span>,
      dataIndex: "fromDateToDate",
      width: 200,
      render: (_, record) => `${record?.start_date} to ${record?.end_date}`,
    },
  ];

  return (
    <>
      <Card
        style={{ width: "500px" }}
        className="text-xl font-semibold mb-8 bg-pink-50 flex-col "
      >
        <h2>PRODUCTION PLAN NUMBER : {data?.production_plan_number}</h2>
        <h2>ORDER NUMBER : {data?.order_number}</h2>
        <h2>COMPLETION DATE : {data?.completion_date}</h2>
        <h2>
          Date: {data && data.createdAt ? data.createdAt.split("T")[0] : "N/A"}
        </h2>
      </Card>

      <Table
        columns={columns}
        dataSource={data?.ProductionPlanDetails}
        scroll={{ x: 1500 }}
      ></Table>
      <div className="flex justify-end">
        <Button type="primary" className="mt-4">
          Confirm
        </Button>
        <Button type="primary" className="mt-4 ml-4">
          Reject
        </Button>
      </div>
    </>
  );
};

export default ProductionDetail;
